export const formatDataForAntdDropdown = (data) => {
    return data.map((e) => {
        return { value: e.dashboard_id, label: e.name };
    });
};
